import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, UnidadeRecurso } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class UnidadeRecursoService extends BaseResourceService<UnidadeRecurso> {

  constructor(
    protected injector: Injector
  ) {
    super(`unidade-recursos`, injector);
  }

}
